<template>
  <div>
    <b-row>
      <b-col cols="12" xl="8">
        <div class="form-container separator">

          <pcg-text-input class="col-12 my-field"
                          :required="true"
                          :label="$t('views.dictionaries.labels.name')"
                          :error-text="getError('name')"
                          :show-error="errorExist('name')"
                          v-model="dictionary.name"/>
          <pcg-text-input class="col-12 my-field my-textarea" type="textarea"
                          :label="$t('views.dictionaries.labels.description')"
                          :error-text="getError('description')"
                          :show-error="errorExist('description')"
                          v-model="dictionary.description"/>
          <pcg-checkbox class="col-12"
                        style="margin-top: 2rem; margin-bottom: 1rem;"
                        :error-text="getError('dictionary_type')"
                        :show-error="errorExist('dictionary_type')"
                        v-model="dictionary.dictionaryTypeBoolean">
            {{$t('views.dictionaries.edit.dictionary_type')}}
          </pcg-checkbox>
          <pcg-btn v-if="dictionary" size="small" @click="updateDictionary(true)" variant="additional" class="action-btn">{{ $t('views.common.save') }}</pcg-btn>
        </div>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import ApiDictionaries from '../../api/dictionaries'

export default {
  name: 'DictionariesEdit',
  components: {
  },
  data () {
    return {
      id: this.$route.params.id,
      errors: {},
      dictionary: {
        name: null,
        description: null,
        dictionaryTypeBoolean: null
      }
    }
  },
  mounted () {
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' })
    this.getDictionary()
  },
  methods: {
    getDictionary () {
      ApiDictionaries.getDictionary(this.id)
        .then(response => {
          this.dictionary = response.data.data.attributes
          if (this.dictionary.dictionaryType === 'open') {
            this.dictionary.dictionaryTypeBoolean = true
          } else {
            this.dictionary.dictionaryTypeBoolean = false
          }
        }).catch(error => {
          this.$toastr.e(error)
          console.log(error)
        })
    },
    setHeader () {
      this.$store.dispatch('header/setHeader', {
        title: this.$t('views.dictionaries.edit.title'),
        subtitle: this.$t('views.dictionaries.edit.subtitle'),
        capitalizeSubtitle: false
      })
    },
    updateDictionary () {
      this.loading = true
      const dictionaryDup = this.dictionary
      if (this.dictionary.dictionaryTypeBoolean) {
        dictionaryDup.dictionaryType = 'open'
      } else {
        dictionaryDup.dictionaryType = 'closed'
      }
      ApiDictionaries.updateDictionary(this.id, { dictionary: dictionaryDup })
        .then(response => {
          this.errors = {}
          this.getDictionary()
          setTimeout(() => { this.$toastr.s(this.$t('general.dictionary_updated')) }, 1)
        }).catch(error => {
          this.errors = error.response.data
          setTimeout(() => { this.$toastr.e(this.$t('general.check_errors')) }, 1)
        }).finally(() => {
          this.loading = false
        })
    },
    getError (field) {
      if (this.errorExist(field)) {
        return this.errors[field].join(', ')
      }
      return ''
    },
    errorExist (field) {
      return !!(this.errors && this.errors[field])
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.setHeader()
    })
  }
}
</script>

<style lang="scss" scoped>
  @import '../../assets/stylesheets/vars';

  .my-field {
    margin-bottom: 1rem;
    position: relative;
    /deep/ .pcg-input-label {
      margin-bottom: 0.25rem;
      color: $pcg-gray;
    }
  }

  .my-textarea {
    /deep/ .pcg-textarea {
      padding-top: 1rem;
      padding-bottom: 1rem;
      border-radius: 15px;
    }
    /deep/ .pcg-field {
      height: 6rem;
      font-size: 1em;
      font-weight: 400;
      color: $pcg-dark-gray;
    }
  }
</style>

<style lang="scss" scoped>
  @import "../../assets/stylesheets/vars-contrast";
  .contrast {
    .my-field {
      /deep/ .pcg-input-label {
        color: $pcg-gray;
      }
    }
    .my-textarea {
      /deep/ .pcg-field {
        color: $pcg-dark-gray;
      }
    }
  }
</style>
